import {Presenter} from '../support/with_presenter';
import {TrainingPlan} from '../models/TrainingPlan';

export interface TrainingPlanProvider {
    get(): Promise<TrainingPlan[]>;
}

export class TrainingPlanSelectorWithInitialDataPresenter implements Presenter {
    public initialTrainingPlans: TrainingPlan[] | null = null;

    constructor(
        private initiallSelectedTrainingPlanIds: number[],
        private trainingPlanProvider: TrainingPlanProvider,
    ) {}

    public async mount(): Promise<void> {
        const trainingPlans = await this.trainingPlanProvider.get();

        this.initialTrainingPlans = this.initiallSelectedTrainingPlanIds.map((id) => {
            return trainingPlans.find((trainingPlan) => trainingPlan.id === id) as TrainingPlan;
        });
    }

    public unmount(): void {
        /* Noop */
    }
}
